

export const formatoMoeda = (valor:number) =>{
  return new Intl.NumberFormat("pt-BR").format(valor);
}